module.exports = "<div ng-class=\"{'container': !isSmallFormat}\" >\r\n\t<wow-store-locator-details store=\"shopLocatorService.selectedStore\" exit=\"closeDetails()\" ng-if=\"shopLocatorService.selectedStore\" class=\"test\"></wow-store-locator-details>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/shoplocator/storedetails/shop-details-panel-template.html
 ** module id = 1016
 ** module chunks = 1
 **/